import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findLocationList = createAsyncThunk(
    "formsubmitted/findLocationList",
    async (arg, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`${api.baseURL}location?select=id,name,partOf,organization,code&populate=organization,partOf&limit=10000`);
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
